import { useEffect, useId, useRef } from 'react';
import type { ReactNode } from 'react';

/** Full-screen sheet with the context cards, for screens too narrow for the side panel. */
export const ContextSheet = ({ onClose, children }: { onClose: () => void; children: ReactNode }) => {
  const titleId = useId();
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeRef.current?.focus();
  }, []);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      className="fixed inset-0 z-40 flex flex-col bg-stone-50 font-geist text-stone-800 lg:hidden"
    >
      <header className="flex items-center justify-between gap-3 border-b border-stone-200 bg-white px-4 py-2">
        <h2 id={titleId} className="m-0 text-base font-semibold text-stone-900">
          Contexto
        </h2>
        <button
          ref={closeRef}
          type="button"
          onClick={onClose}
          className="inline-flex h-11 items-center rounded-full border border-stone-200 bg-white px-5 text-sm font-semibold text-stone-800 hover:bg-stone-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
        >
          Cerrar
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto p-4">{children}</div>
    </div>
  );
};
